var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('menuComponent',{attrs:{"lang":_vm.lang,"sub":_vm.subMenu,"names":[]}}),_c('footerComponent',{attrs:{"lang":_vm.lang}}),_c('floors',{attrs:{"data":_vm.currentPage,"lang":_vm.lang}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }